import React from 'react';
import { Helmet } from 'react-helmet-async';

// Styles are inline and self-contained so this page renders correctly on its
// own, independent of the rest of the site's stylesheets.
const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
    backgroundColor: '#f8f9fb',
    fontFamily:
      "'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif",
    color: '#333333',
  },
  card: {
    maxWidth: '560px',
    width: '100%',
    backgroundColor: '#ffffff',
    borderRadius: '10px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
    padding: '40px 32px',
    textAlign: 'center',
  },
  heading: {
    margin: '0 0 16px',
    fontSize: '1.8rem',
    fontWeight: 600,
    color: '#2E3192',
    lineHeight: 1.3,
  },
  message: {
    margin: 0,
    fontSize: '1rem',
    lineHeight: 1.7,
    color: '#555555',
  },
};

export default function Suspended() {
  return (
    <div style={styles.page}>
      <Helmet>
        <title>Website Temporarily Unavailable</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta
          name="description"
          content="This website has been temporarily suspended."
        />
      </Helmet>
      <main style={styles.card}>
        <h1 style={styles.heading}>Website Temporarily Unavailable</h1>
        <p style={styles.message}>
          This website has been temporarily suspended. Please contact the site
          administrator for more information.
        </p>
      </main>
    </div>
  );
}
